import { render, staticRenderFns } from "./PeriodTable.vue?vue&type=template&id=5e42e3d9"
import script from "./PeriodTable.vue?vue&type=script&lang=js"
export * from "./PeriodTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports